import { useTheme } from "@mui/material";
import React, { forwardRef } from "react";

interface DarkModeLogoProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export const DarkModeLogo = forwardRef<HTMLSpanElement, DarkModeLogoProps>(
  ({ children, style = {}, className }, ref) => {
    const theme = useTheme();

    const darkModeStyles =
      theme.palette.mode === "dark"
        ? {
            backgroundColor: theme.palette.grey[100],
            padding: "4px",
            borderRadius: "4px",
          }
        : {};

    return (
      <span
        ref={ref}
        role="presentation"
        className={className}
        style={{
          display: "inline-block",
          ...darkModeStyles,
          ...style,
        }}
      >
        {children}
      </span>
    );
  },
);
